<app-mmp-ai-summary
  [progressTagMsg]="progressTagMsg"
  progressTagClass="completed"
  [courseCount]="aiSummaryCourseCount"
  [notTransferForCredit]="notTransferForCredit"
  [transferForCredit]="transferForCredit"
  [confidenceScore]="aiSummaryConfidenceScore"
  [currentTab]="currentStage"
  [progressTimeText]="progressTimeText"
  [progressTime]="progressTime"
></app-mmp-ai-summary>
<div class="evaluation-container">
  <div class="evaluation-body">
    <div class="tab-header-wrapper">
      <mat-tab-group
        class="transcript-group"
        [(selectedIndex)]="selectedTranscriptIndex"
        (click)="onTranscriptTabClick($event)"
        (keydown)="onTranscriptTabClick($event)"
        (selectedIndexChange)="onTranscriptTabChange($event)"
      >
        @for (
          transcript of evaluationResult.transcripts;
          track transcript;
          let i = $index
        ) {
          <mat-tab [label]="transcript.name">
            <ng-template mat-tab-label>
              <span
                class="transcript-tab-label-text"
                [title]="transcript.name"
              >
                {{ transcript.name }}
              </span>
            </ng-template>
            <div class="tab-heading horizontal-line">
              <div class="university-name" title="{{ transcript.university }}">
                {{ transcript.university }}
              </div>
              <div class="transfer-count">
                <b>{{ getSelectedCoursesCount(transcript) }}</b
                >/{{ getTotalCoursesCount(transcript) }}
                <b>Courses Transfer for Credit</b>
              </div>
            </div>
            <div class="tab-content evaluation-content">
              <div
                class="accordion accordion-flush mt-2"
                id="transcriptAccordion"
              >
                @for (
                  course of getFilteredCourses(evaluationResult.transcripts[i]);
                  track course;
                  let j = $index
                ) {
                  <div class="accordion-item credit-evaluation">
                    <h2
                      class="accordion-header d-flex justify-content-between align-items-center"
                      [id]="'heading' + j"
                    >
                      <button
                        class="accordion-button d-flex justify-content-between align-items-center text-start"
                        type="button"
                        [ngClass]="{ collapsed: activeAccordion !== j }"
                        (click)="toggleAccordion(j)"
                      >
                        <div
                          class="d-flex align-items-center course-name-container"
                        >
                          <input
                            type="checkbox"
                            class="course-checkbox me-2"
                            [id]="'checkbox' + j"
                            [checked]="course.selected"
                            (change)="
                              onCourseCheckboxChange(i, course.origin, $event)
                            "
                            (click)="preventAccordionToggle($event)"
                            (keydown)="preventAccordionToggle($event)"
                          />
                          <span
                            class="course-name"
                            [title]="course.course_name | titleCase"
                          >
                            {{ course.course_name | titleCase }}
                          </span>
                        </div>
                        <div class="d-flex align-items-center text-end gap-1">
                          <span class="credits-badge ms-2">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1928_1018)">
                                <path
                                  d="M4 6C4 7.06087 4.42143 8.07828 5.17157 8.82843C5.92172 9.57857 6.93913 10 8 10C9.06087 10 10.0783 9.57857 10.8284 8.82843C11.5786 8.07828 12 7.06087 12 6C12 4.93913 11.5786 3.92172 10.8284 3.17157C10.0783 2.42143 9.06087 2 8 2C6.93913 2 5.92172 2.42143 5.17157 3.17157C4.42143 3.92172 4 4.93913 4 6Z"
                                  stroke="#088E6D"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8 10L10.2667 13.9267L11.332 11.7713L13.7307 11.926L11.464 8"
                                  stroke="#088E6D"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.5362 8L2.26953 11.9267L4.6682 11.7713L5.73353 13.926L8.0002 10"
                                  stroke="#088E6D"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1928_1018">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <span class="badge-label"
                              >Credits: {{ course.quarter_credits }}</span
                            >
                          </span>
                          @if (
                            ComparisonNormalizer.string(course.course_status) ==
                            "not transfer for credit"
                          ) {
                            <span class="transfer-credits">{{
                              course.course_status
                            }}</span>
                          }
                          @if (
                            ComparisonNormalizer.string(course.course_status) ==
                            "transfer for credit"
                          ) {
                            <span
                              class="transfer-credits-green transfer-credits"
                              >{{ course.course_status }}</span
                            >
                          }
                        </div>
                      </button>
                    </h2>
                    <div
                      [id]="'collapse' + j"
                      class="accordion-collapse collapse"
                      [ngClass]="{
                        show: activeAccordion === j,
                      }"
                      [attr.aria-labelledby]="'heading' + j"
                      data-bs-parent="#transcriptAccordion"
                    >
                      <div class="accordion-body">
                        <div class="course-details">
                          <div class="course-block">
                            <div class="title-heading">Course Code:</div>
                            <div class="value">{{ course.course_code }}</div>
                          </div>
                          <div class="course-block">
                            <div class="title-heading">Attendance Date:</div>
                            <div class="value">{{ course.semester }}</div>
                          </div>
                          <div class="course-block">
                            <div class="title-heading">Grade:</div>
                            <div class="value">{{ course.grade }}</div>
                          </div>
                          <div
                            class="hide-rule"
                            (click)="toggleRulesVisibility(course)"
                            (keydown.enter)="toggleRulesVisibility(course)"
                          >
                            {{ course.showRules ? "Hide Rules" : "View Rules" }}
                          </div>
                        </div>
                        @if (course.showRules) {
                          <div class="rules-checked">
                            <div class="rules-checked-title">Rules Checked</div>
                          </div>
                        }
                        @if (course.showRules) {
                          <div>
                            @for (rule of course.rules_checked; track rule) {
                              <div class="rules-section horizontal-line">
                                <div class="rule-left">
                                  <div class="rule-name">
                                    {{ rule.rule_name }}
                                  </div>
                                  <div class="rule-reason">
                                    {{ rule.reason }}
                                  </div>
                                </div>
                                <div class="rule-right">
                                  @if (
                                    ComparisonNormalizer.string(rule.status) ===
                                    "satisfied"
                                  ) {
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1261_18349)">
                                        <path
                                          d="M12.75 2.50498C13.8812 3.15812 14.8222 4.09537 15.4799 5.22396C16.1375 6.35254 16.489 7.63331 16.4996 8.93949C16.5101 10.2457 16.1794 11.5319 15.54 12.671C14.9007 13.8101 13.9749 14.7624 12.8544 15.4337C11.7339 16.1051 10.4575 16.4721 9.15157 16.4985C7.84562 16.525 6.55541 16.2099 5.40867 15.5844C4.26192 14.959 3.2984 14.0449 2.6135 12.9326C1.9286 11.8204 1.54606 10.5485 1.50375 9.24298L1.5 8.99998L1.50375 8.75698C1.54575 7.46172 1.92266 6.19945 2.59773 5.09323C3.2728 3.987 4.22299 3.07457 5.35567 2.44489C6.48835 1.81522 7.76486 1.48978 9.06075 1.50031C10.3566 1.51084 11.6277 1.85698 12.75 2.50498ZM11.7802 6.96973C11.6511 6.8406 11.4793 6.76302 11.297 6.75156C11.1147 6.7401 10.9346 6.79554 10.7902 6.90748L10.7198 6.96973L8.25 9.43873L7.28025 8.46973L7.20975 8.40748C7.06544 8.29562 6.88528 8.24025 6.70305 8.25175C6.52083 8.26324 6.34906 8.34082 6.21995 8.46993C6.09084 8.59904 6.01326 8.77081 6.00177 8.95303C5.99027 9.13526 6.04564 9.31542 6.1575 9.45973L6.21975 9.53023L7.71975 11.0302L7.79025 11.0925C7.92178 11.1945 8.08352 11.2499 8.25 11.2499C8.41648 11.2499 8.57822 11.1945 8.70975 11.0925L8.78025 11.0302L11.7802 8.03023L11.8425 7.95973C11.9544 7.81543 12.0099 7.63524 11.9984 7.45297C11.987 7.2707 11.9094 7.09888 11.7802 6.96973Z"
                                          fill="#088E6D"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1261_18349">
                                          <rect
                                            width="18"
                                            height="18"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  }
                                  @if (
                                    ComparisonNormalizer.string(rule.status) ===
                                    "not satisfied"
                                  ) {
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1261_18356)">
                                        <path
                                          d="M12.75 2.50504C13.8812 3.15818 14.8222 4.09544 15.4799 5.22402C16.1375 6.3526 16.489 7.63337 16.4996 8.93955C16.5101 10.2457 16.1794 11.532 15.54 12.6711C14.9007 13.8101 13.9749 14.7625 12.8544 15.4338C11.7339 16.1051 10.4575 16.4722 9.15157 16.4986C7.84562 16.525 6.55541 16.2099 5.40867 15.5845C4.26192 14.959 3.2984 14.0449 2.6135 12.9327C1.9286 11.8204 1.54606 10.5486 1.50375 9.24304L1.5 9.00004L1.50375 8.75704C1.54575 7.46178 1.92266 6.19951 2.59773 5.09329C3.2728 3.98706 4.22299 3.07463 5.35567 2.44495C6.48835 1.81528 7.76486 1.48984 9.06075 1.50037C10.3566 1.5109 11.6277 1.85704 12.75 2.50504ZM7.88325 6.85504C7.72611 6.7615 7.54021 6.72859 7.36051 6.76251C7.18081 6.79643 7.01969 6.89484 6.90746 7.03923C6.79523 7.18361 6.73962 7.36403 6.75109 7.54654C6.76257 7.72906 6.84033 7.90109 6.96975 8.03029L7.93875 9.00004L6.96975 9.96979L6.9075 10.0403C6.79094 10.191 6.73613 10.3805 6.7542 10.5702C6.77227 10.7599 6.86187 10.9356 7.00479 11.0616C7.14772 11.1876 7.33325 11.2545 7.52371 11.2487C7.71417 11.2429 7.89528 11.1648 8.03025 11.0303L9 10.0613L9.96975 11.0303L10.0402 11.0925C10.191 11.2091 10.3805 11.2639 10.5701 11.2458C10.7598 11.2278 10.9355 11.1382 11.0616 10.9952C11.1876 10.8523 11.2545 10.6668 11.2487 10.4763C11.2429 10.2859 11.1648 10.1048 11.0302 9.96979L10.0612 9.00004L11.0302 8.03029L11.0925 7.95979C11.2091 7.80905 11.2639 7.61959 11.2458 7.4299C11.2277 7.2402 11.1381 7.0645 10.9952 6.93848C10.8523 6.81245 10.6667 6.74555 10.4763 6.75137C10.2858 6.75719 10.1047 6.83528 9.96975 6.96979L9 7.93879L8.03025 6.96979L7.95975 6.90754L7.88325 6.85504Z"
                                          fill="#FA0000"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1261_18356">
                                          <rect
                                            width="18"
                                            height="18"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
      <!-- Toggle on right -->
      <div class="header-toggle">
        Selected for Transfer
        <label class="switch">
          <input type="checkbox" [(ngModel)]="isTransferToggleChecked" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="evaluation-feedback">
    <app-mmp-feedback [feedBackStage]="currentStage"></app-mmp-feedback>
  </div>
  <div class="evaluation-footer">
    <button class="mmp-btn-secondary" (click)="goToExtractionTab()">
      Back
    </button>
    <button
      class="mmp-btn-primary"
      (click)="handleSaveAndProceedClick($event)"
      [class.disabled]="
        getSelectedCoursesCount() === 0 || progressTagMsg !== 'Completed'
      "
      [matTooltip]="
        getSelectedCoursesCount() === 0
          ? 'Please select at least one course to continue'
          : progressTagMsg !== 'Completed'
            ? 'Evaluation is still in progress. Please wait until it is completed to continue'
            : ''
      "
    >
      Save & Proceed to Equivalency
    </button>
  </div>
</div>
